// Build an element from a plant (meili object) — ported from v1's
// makePlantElement. Width (m) -> diameter in plan units (1 unit = 1 cm), a
// lobed canopy, and a species label.

import { DEFAULT_FILL_COLOR } from './migrations';

export function makePlantElement(species, x, y) {
  const size = species.Width && species.Width !== 'not specified' ? parseFloat(species.Width) : 1;
  const layer = Array.isArray(species.Layer) ? species.Layer[0] : species.Layer;
  const keys = species.type !== 'Variety'
    ? ['name', 'scientific_name']
    : ['parent_name', 'name', 'scientific_name'];
  return {
    id: `el-${Date.now()}-${Math.round(x)}-${Math.round(y)}`,
    type: 'ellipse',
    speciesIds: [species.id],
    data: {
      x, y,
      width: (size || 1) * 100,
      height: (size || 1) * 100,
      labels: [{ type: 'species', id: species.id, keys }],
      labelX: 0, labelY: 0,
      fillColor: DEFAULT_FILL_COLOR, strokeColor: null, strokeWidth: null,
      layer: layer || null,
      canopyStyle: 'lobed',
      canopySeed: Math.floor(Math.random() * 100000),
      addedDate: null, removedDate: null,
    },
  };
}

export function plantDiameter(species) {
  const size = species.Width && species.Width !== 'not specified' ? parseFloat(species.Width) : 1;
  return (size || 1) * 100;
}
